import dayjs from "dayjs";
import { Constants } from "../../utils/constants";
import { InternalListUsers, ResponseGroupList, ResponseWithOPutPagiantion, RowItemGroup, UserPermissionList } from "./response";

const formatUserGroupList = ({ response }: { response: ResponseGroupList }) => {

    const row: RowItemGroup[] = !response.errors
        ? response?.items.map((item) => {

            return {
                createTime: String(dayjs(item.createTime).format(Constants.dayjsFormat)),
                name: item.name,
                id: item.id,
                externalUsers: item.externalUsers,
                internalUsers: item.internalUsers,
                creatorUser: item.fullNameUserCreator
            }
        })
        : []

    return {
        row
    }
}

const formatUserGroupListWithOutPagination = ({ response }: { response: ResponseWithOPutPagiantion }) => {

    const row: RowItemGroup[] = !response.errors
        ? response?.map((item) => {

            return {
                createTime: String(dayjs(item.createTime).format(Constants.dayjsFormat)),
                name: item.name,
                id: item.id,
                externalUsers: item.externalUsers,
                internalUsers: item.internalUsers,
                creatorUser: item.fullNameUserCreator
            }
        })
        : []

    return {
        row
    }
}

const formatListInternalUsers = ({ response }: { response: InternalListUsers }) => {

    const row = response.items.map(item => {
        const userDepartments = item.userDepartments ?? [];

        const areaName = userDepartments
            .filter(a => a.areaId != null)
            .map(a => a.areaName)
            .join(', ');

        const departmentName = userDepartments
            .filter(d => d.departmentId != null)
            .map(d => d.departmentName)
            .join(', ');

        return {
            name: `${item.firstName} ${item.lastName}`,
            role: item.role.description ?? '',
            userType: item.userType.name ?? '',
            areaName,
            departmentName
        };
    });

    const totalPages = response.totalPages

    const totalSelected = response.totalItems

    return { row, totalPages, totalSelected };
}

const fortmatUserPermission = ({ response }: { response: UserPermissionList }) => {
    const row = response?.errors ? [] :
        response.map(item => {
            const userDepartments = item.userDepartments ?? [];

            const areaName = userDepartments
                .filter(a => a.areaId != null)
                .map(a => a.areaName)
                .join(', ');

            const departmentName = userDepartments
                .filter(d => d.departmentId != null)
                .map(d => d.departmentName)
                .join(', ');
            return {
                id: item.id,
                name: `${item.firstName} ${item.lastName}`,
                area: areaName,
                department: departmentName,
                userType: item.userType?.name ?? '',
                role: item.role.description,
                applies: true,
                delete: false
            }
        })

    return { row }
}

export { formatUserGroupList, formatListInternalUsers, formatUserGroupListWithOutPagination, fortmatUserPermission }